export { MarketingAiModal as default } from "./marketing-ai-modal";
export type { MarketingAiModalProps } from "./marketing-ai-modal";

